import { PREFIX_URL } from '@/src/api/config';

export const QUICKBOOKS_BASE_URL = `${PREFIX_URL}/quickbooks`;

export const DOCUMENT_BASE_URL = `${PREFIX_URL}/v01/document`;

export const INBOX_DOCUMENT_BASE_URL = `${PREFIX_URL}/inbox-documents`;
